
<div class="flex justify-between items-center gap-2 font-rubik">
  <div 
    class="status-circle" 
    :class="{ 'status-circle-active': !isActive }"
  ></div>

  <div class="flex items-center font-rubik">
    <button
      @click="toggle"
      class="toggle-container relative inline-flex items-center h-7 w-14 rounded-full focus:outline-none"
    >
      <div
        class="w-full"
        :class="{ 'text-left pl-1': isActive, 'text-right pr-1': !isActive }"
      >
        <p class="button-text">{{ isActive ? 'BUY' : 'RENT' }}</p>
      </div>
      <span
        class="absolute toggle-arrow w-6 h-6 bg-white rounded-full shadow"
        :class="{ 'toggle-active': isActive, 'toggle-inactive': !isActive }"
      ></span>
    </button>
  </div>

  <div 
    class="status-circle" 
    :class="{ 'status-circle-active': isActive }"
  ></div>
</div>
